export const BOT_USER_AGENT_PATTERN = /bot|googlebot|crawler|spider|robot|crawling/i

export default !!(typeof navigator !== 'undefined' &&
  BOT_USER_AGENT_PATTERN.test(navigator.userAgent ?? ''))
